module.exports = __webpack_public_path__ + "img/text3.8e10a951.png";